import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  LOAN_STATE,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}loans`;

export interface GetLoansQueryArgs {
  fileId?: string;
  sellerId?: string;
}

export interface LoanDto {
  id: string;
  state: LOAN_STATE;
  // Keep the rest of fields flexible until a stricter model is required
  [key: string]: unknown;
}

export const getLoansRequest = (
  payload: GetLoansQueryArgs = {},
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, { fileId: payload.fileId, sellerId: payload.sellerId }),
  config: { method: SUPPORTED_METHODS.GET },
});

export async function getLoansQuery(
  payload: GetLoansQueryArgs = {},
): Promise<BackResponse<LoanDto[]> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<LoanDto[]>>(getLoansRequest(payload));
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
